import { gsap } from "gsap";

export default function () {
    const servicesTimeline = gsap.timeline()
    if (!document.querySelector('[data-block="services"]'))
        return servicesTimeline

    const servicesHeading = gsap.timeline({
            scrollTrigger: {
                trigger: '[data-block="services"]',
                start: 'top center',
                scrub: false,
                once: true
            }
        })

    servicesHeading.from('[data-block="services-heading"] > h2', { opacity: 0, y: 40 })
        .from('[data-block="services-heading"] > span', { opacity: 0, y: -40 }, '<')
        .from('[data-block="services-heading"] + p', { opacity: 0, y: 40 }, '>')

    gsap.from('[data-block="services-items"]', {
            opacity: 0,
            y: 40,
            scrollTrigger: {
                trigger: '[data-block="services-items"]',
                start: 'top center',
                scrub: false,
                once: true
            }
        })

    // TODO: přidat do timeliny ?!

    document.querySelector('[data-block="services-items"]').querySelectorAll('aside')
        .forEach(aside => aside.addEventListener('click', () => {
            (aside.closest('details')).open = false
        }))

    return servicesTimeline
}